import { render, staticRenderFns } from "./scope43.vue?vue&type=template&id=5e53bffa&scoped=true"
import script from "./scope43.vue?vue&type=script&lang=js"
export * from "./scope43.vue?vue&type=script&lang=js"
import style0 from "./scope43.vue?vue&type=style&index=0&id=5e53bffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53bffa",
  null
  
)

export default component.exports